// @flow
import queryString from 'query-string';
import deepEqual from 'react-fast-compare';
import type { Location } from 'react-router';
import { objectEmpty, updateObject, filterNulls } from 'utils/functional';

export const withParams = (l: Location, params: { [string]: string }) => ({
  ...l,
  search: queryString.stringify(
    updateObject(queryString.parse(l.search), params)
  )
});

export const searchEqual = (l1: Location, l2: Location) =>
  deepEqual(queryString.parse(l1.search), queryString.parse(l2.search));

const trimTrailingSlash = (s: string) => s.replace(/\/$/, '');

export const pathnameEqual = (p1: string, p2: string) =>
  trimTrailingSlash(p1) === trimTrailingSlash(p2);

export const pathWithParams = (
  path: string,
  params: $ReadOnly<{ [string]: ?string }>
) =>
  objectEmpty(params)
    ? path
    : `${trimTrailingSlash(path)}?${queryString.stringify(
        filterNulls(params)
      )}`;

export const hasParam = (search: string, param: string) =>
  param in queryString.parse(search);

export const getParam = (
  l: Location,
  param: string,
  onlyFirst: boolean = false
) => {
  const q = queryString.parse(l.search)[param];
  return onlyFirst && Array.isArray(q) ? q[0] : q;
};

export const removeParam = (qs: string, param: string) =>
  qs
    .split('&')
    .filter(
      queryParam =>
        !(queryParam === param || queryParam.startsWith(`${param}=`))
    )
    .join('&');

export const isUrlWithProtocol = (url: string) => /^https?:\/\//.test(url);
